module.exports = new __parcel__URL__("movie-case.43301a8e.png").toString();